/**
 * Moves sold-out product cards to the end of each rendered collection grid,
 * without touching the underlying Shopify collection sort or data.
 * Re-partitions the full current DOM set on every mutation, so it stays
 * correct across filter changes, sort changes, pagination, and infinite scroll.
 */
(function () {
  function reorderGrid(grid) {
    if (!grid || grid.dataset.soldOutSorting === 'true') return;
    grid.dataset.soldOutSorting = 'true';

    var items = Array.prototype.slice.call(grid.children).filter(function (el) {
      return el.hasAttribute('data-available');
    });
    if (!items.length) {
      delete grid.dataset.soldOutSorting;
      return;
    }

    var inStock = [];
    var soldOut = [];
    items.forEach(function (el) {
      if (el.getAttribute('data-available') === 'false') {
        soldOut.push(el);
      } else {
        inStock.push(el);
      }
    });

    var desired = inStock.concat(soldOut);
    var alreadyOrdered = desired.every(function (el, i) {
      return items[i] === el;
    });

    if (!alreadyOrdered) {
      var fragment = document.createDocumentFragment();
      desired.forEach(function (el) {
        fragment.appendChild(el);
      });
      grid.appendChild(fragment);
    }

    delete grid.dataset.soldOutSorting;
  }

  function observeGrid(grid) {
    if (!grid || grid.dataset.soldOutObserved === 'true') return;
    grid.dataset.soldOutObserved = 'true';

    reorderGrid(grid);

    var observer = new MutationObserver(function () {
      reorderGrid(grid);
    });
    observer.observe(grid, { childList: true });
  }

  function scanForGrids(root) {
    var containers = (root || document).querySelectorAll('[data-products-grid]');
    containers.forEach(function (container) {
      var grid = container.classList.contains('grid') ? container : container.querySelector('.grid');
      observeGrid(grid);
    });
  }

  scanForGrids(document);

  // Sections re-render (filters, sort, pagination) can replace the whole
  // [data-products-grid] container, so watch the page body for new ones too.
  var pageObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('[data-products-grid]')) {
          var grid = node.classList.contains('grid') ? node : node.querySelector('.grid');
          observeGrid(grid);
        } else if (node.querySelectorAll) {
          scanForGrids(node);
        }
      });
    });
  });
  pageObserver.observe(document.body, { childList: true, subtree: true });
})();
